// extracted by mini-css-extract-plugin
module.exports = {"container":"q47uJqBZ","wrapper":"iUcv0QxW","img":"OWQh12pq","title":"cVbVRy8D","description":"pV2z7TY_"};